module.exports = __webpack_public_path__ + "static/media/camera.919a9f74.svg";